import { render, staticRenderFns } from "./RotateSquare2.vue?vue&type=template&id=4d23a688&scoped=true&"
import script from "./RotateSquare2.vue?vue&type=script&lang=js&"
export * from "./RotateSquare2.vue?vue&type=script&lang=js&"
import style0 from "./RotateSquare2.vue?vue&type=style&index=0&id=4d23a688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d23a688",
  null
  
)

export default component.exports